export const scrollTopAuto = (top: number) => {
  const html = document.querySelector('html');
  html?.classList.add('scroll-auto');
  window.scrollTo({ top, behavior: 'auto' });
  html?.classList.remove('scroll-auto');
};
